import { IBodyDisplayUnits } from "features/profile/profileTypes"

export const getDefaultBodyDisplayUnit = (): IBodyDisplayUnits => {
  try {
    const locale = new Intl.NumberFormat().resolvedOptions().locale
    const region = new Intl.Locale(locale).region
    return region === "US" ? "IMPERIAL" : "METRIC"
  } catch {
    return "IMPERIAL"
  }
}
